import bootLayout from 'static/script/app/boot/boot-layout';
import bootItemResultList from 'static/script/app/boot/boot-item-result-list';
import DeferLoad from 'static/script/app/ui/defer-load';
import FavouriteSellersUI from 'static/script/app/ui/view-item/favourite-sellers-ui';
import FavouriteSellersService from 'static/script/app/data/favourite-sellers-service';
import triot from 'triot';
import messageValidation from 'static/script/utils/message-validation';
import CommentFeedbackButton from 'static/script/app/ui/comment-feedback/comment-feedback-button';
import contactService from 'static/script/app/data/contact-service';
import breakpoints from 'static/script/utils/breakpoints';
import Pagination from 'static/script/app/ui/search-result/pagination';
import ScrollToTopUI from 'static/script/app/ui/search-result/scroll-to-top-ui';
import 'static/output/script/riot-core-tags';
import 'static/script/app/ui/comment-feedback/comment-feedback-modal-mixin';

module.exports = initData => {
    bootLayout(initData);
    bootItemResultList(initData);
    DeferLoad.attachTo('body');
    FavouriteSellersService.attachTo(document);
    FavouriteSellersUI.attachTo('[data-favourite-seller-add]');
    ScrollToTopUI.attachTo('[data-scroll-to-top]');
    Pagination.attachTo('[data-pagination]');

    let commentFeedbackService = contactService({
        url: '/profile/feedback/reply-to-negative-feedback',
        gaEvent_success: {
            category: 'Profile',
            label: 'Comment Feedback - message sent',
            action: 'Navigation',
            userTriggered: true
        },
        gaEvent_error: {
            category: 'Profile',
            label: 'Comment Feedback - message error',
            action: 'Navigation',
            userTriggered: true
        }
    });

    CommentFeedbackButton.attachTo('[data-comment-feedback]', {bus: triot.bus});
    triot.mount('[data-contact-seller-modal]', 'comment-feedback-modal', { contactService: commentFeedbackService, validator: messageValidation, breakpoints: breakpoints });
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/profile.js